import script from "./essensTvPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./essensTvPromo.vue?vue&type=script&setup=true&lang=js"

import "./essensTvPromo.vue?vue&type=style&index=0&id=626a585c&lang=css"

const __exports__ = script;

export default __exports__